export default {
    methods: {
        scrollToTop() {
            this.$el.closest('.flex-fill')?.scrollIntoView({ behavior: 'smooth' })
        },
        formatKey(key) {
            let words = key.replace(/_/g, ' ').replace(/([A-Z])/g, ' $1').trim()
            return words.charAt(0).toUpperCase() + words.slice(1)
        },
        truncate(value, maxLength = 250) {
            if (!value) return ''
            let str = typeof value === 'string' ? value : JSON.stringify(value)
            return str.length > maxLength ? str.substring(0, maxLength) + '...' : str
        }
    }
}
